import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';

import {ValveManufacturerInputValveManufacturersQuery} from './__generated__/ValveManufacturerInputValveManufacturersQuery.graphql';
import DropdownInput from './DropdownInput';

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
};

function ValveManufacturerInput(props: Props) {
  const data = useLazyLoadQuery<ValveManufacturerInputValveManufacturersQuery>(
    valveManufacturersQuery,
    {},
    {fetchPolicy: 'store-and-network'},
  );

  const {error, value, onChange} = props;

  const options = !!data
    ? data.valveManufacturers.edges.map(valveManufacturerEdge => ({
        label: valveManufacturerEdge.node.name,
        value: valveManufacturerEdge.node.id,
      }))
    : [];

  return (
    <DropdownInput
      name="valveManufacturerInput"
      onChange={onChange}
      options={options}
      placeholder="E.g. Milliken"
      label="Manufacturer"
      value={value}
      error={error}
    />
  );
}

const valveManufacturersQuery = graphql`
  query ValveManufacturerInputValveManufacturersQuery {
    valveManufacturers {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export default ValveManufacturerInput;
